import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerLeftUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowCornerLeftUp"><Path fillRule="evenodd" clipRule="evenodd" d="M8.75011 2.68945L3.68945 7.75011L4.75011 8.81077L8.00011 5.56077V21.0001H20.0001V19.5001H9.50011V5.56077L12.7501 8.81077L13.8108 7.75011L8.75011 2.68945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerLeftUp;
